import { Redirect, useLocalSearchParams } from 'expo-router';

import { routes } from 'navigation/routing';
import { BadgeDetailModal } from 'pages/loyalty/loyalty-badges/badge-detail-modal';
import { useBadgeAnimationSource } from 'pages/loyalty/loyalty-badges/use-badge-animation-source';
import { useGetLoyaltyBadges } from 'pages/loyalty/loyalty-badges/use-get-loyalty-badges';
import { stringToBool } from 'utils/string-To-Bool';

export default function BadgeDetailRoute() {
  const queryParams = useLocalSearchParams<{
    justEarned: string;
    badgeId: string;
  }>();
  const badgeId = queryParams.badgeId;
  const justEarned = !!stringToBool(queryParams.justEarned);
  const { badges, initialLoading, loading } = useGetLoyaltyBadges({
    fetchPolicy: 'cache-first',
  });

  const selectedBadge = badges?.find(badge => badge.id === badgeId);
  const animationSource = useBadgeAnimationSource({
    lottie: selectedBadge?.lottie,
    showCelebration: justEarned,
  });
  const isLoading = initialLoading || animationSource.isPreparing;

  // Use Apollo's raw `loading` instead of `initialLoading` here: with cache-and-network,
  // stale cache may not yet include a just-earned badge while a background refetch is in
  // flight. Redirecting on `initialLoading` would bail before the network response arrives.
  if (!isLoading && !loading && !selectedBadge) {
    return <Redirect href={routes.rewardsProfile} />;
  }

  return (
    <BadgeDetailModal
      badge={selectedBadge}
      isLoading={isLoading}
      showCelebration={justEarned}
      animationSource={animationSource}
    />
  );
}
